import { FunctionComponent, PropsWithChildren } from "react";

import * as Styled from "./styles";
import Container from "../../layout/container";
import Flex from "../../layout/flex";

const Footer: FunctionComponent<PropsWithChildren> = ({ children }: PropsWithChildren) => {
  return (
    <Styled.FooterDiv id="footer">
      <Container>
        <Flex $flexGap={16} $flexDirection="column">
          {children}
        </Flex>
      </Container>
    </Styled.FooterDiv>
  );
};

export default Footer;
